export const isAttributeEditable = <
  T extends { permittedAttributes: string[] }
>(
  entity: T,
  attribute: string & keyof T
): boolean => {
  return entity.permittedAttributes.includes(attribute);
};
